import { render, staticRenderFns } from "./TwitchPost.vue?vue&type=template&id=85c28ea4&"
import script from "./TwitchPost.vue?vue&type=script&lang=ts&"
export * from "./TwitchPost.vue?vue&type=script&lang=ts&"
import style0 from "./TwitchPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports